
import moment from 'moment';
import React, { useContext } from 'react';
import { sum_amount_total_card, sum_amount_total_cash } from '../../../../functions/fun_sum';
import { View_Day, view_month_ar } from '../../../../functions/fun_view';
import sum_amount from '../../../../functions/sum_total_amount';
import FooterInvoice from '../../../invoice/FooterInvoice';
import HeaderInvoice from '../../../invoice/HeaderInvoice';
import './invoice.css';
import { InvoiceContext } from './Invoice_Context';

function InvoicePaymentsDay()
{
    const data = useContext(InvoiceContext)
    const {payments_month,payment_types,totals_month}=data
   // formatter بسيط
   const money = (v) =>
    `${Number(v || 0).toLocaleString("en-US")} د.ل`;
    return (
    <div className='col-md-12'>
        <div id="invoice" className="page-content fade-in-up" dir="rtl">
            <div className="ibox invoice-print">
                <div className="invoice-header">
                    <div className="row">
                        <div className="col-12">
                            <HeaderInvoice title={
                                <p style={{fontWeight:"bold"}}>
                                 مدفوعات لشهر

                                <p className='mt-2'>
                                    {view_month_ar(payments_month[0]?.date)}-{moment(payments_month[0]?.date).format("MM-YYYY")}
                                </p>


                                </p>
                            }/>
                        </div>
                    </div>
                </div>
                <table className="table table-bordered table-striped no-margin table-invoice" style={{fontSize:"16px"}}>
                        <thead className="color-view bg- ">
                            <tr>
                                <th style={{fontSize:"14px",textAlign:"center",fontWeight:"bold"}} colSpan={payment_types.length+2}>إجمـــالي الشهــر</th>
                            </tr>
                            <tr >
                                <th style={{fontSize:"14px",textAlign:"center"}}>عدد الأيام</th>
                                {
                                    payment_types?.map(item=>{
                                        return (
                                            <th style={{fontSize:"14px",textAlign:"center"}}>
                                                {item.name_payment_type}
                                            </th>
                                        )
                                    })
                                }
                               <th style={{fontSize:"14px",textAlign:"center"}}>إجمـــالي المبلـــغ</th>
                            </tr>
                            <tr>
                                <td>{totals_month?.count_days}</td>
                                {payment_types?.map((item)=>{
                                        const v = totals_month?.methods?.[String(item.id_payment_type)] ?? 0;
                                        return <td  style={{fontSize:"14px",textAlign:"center"}}>
                                                <span style={{ color: Number(v) < 0 ? "red" : "black" }}>
                                                    {money(v)}
                                                </span>
                                            </td>
                                    })}
                                <td  style={{fontSize:"14px",textAlign:"center"}}>
                                    <span style={{ color: Number(totals_month?.amount) < 0 ? "red" : "green",fontWeight:"bold" }}>
                                        {money(totals_month?.amount)}
                                    </span>
                                </td>
                            </tr>
                        </thead>
                </table>
                <table className="table table-bordered table-striped no-margin table-invoice ">
                    <thead className="color-view" >
                        <tr>
                            <th style={{fontSize:"14px",textAlign:"center",fontWeight:"bold"}} colSpan={payment_types.length+2}>تفصيــل لكــل يــوم</th>
                        </tr>
                        <tr >
                            <th style={{fontSize:"14px",textAlign:"center"}}>اليوم</th>
                           {
                            payment_types?.map(item=>{
                                return (
                                    <th style={{fontSize:"14px",textAlign:"center"}}>{item?.name_payment_type}</th>
                                )
                            })
                           }
                            <th style={{fontSize:"14px",textAlign:"center"}}>إجمـــالي المبلـــغ</th>
                        </tr>
                    </thead>
                    <tbody style={{fontSize:"13px",textAlign:"center"}}>

                        {
                            payments_month?.map((payment)=>{
                                return(
                                <>
                                <tr>
                                    <td>
                                        {moment(payment?.date).format("MM-DD")}
                                        <br></br>
                                        {payment?.day_name}
                                    </td>
                                    {payment_types?.map((item)=>{
                                         const v = payment?.methods?.[String(item.id_payment_type)] ?? 0;
                                        return <td>
                                                <span style={{ color: Number(v) < 0 ? "red" : "black" }}>
                                                    {money(v)}
                                                </span>
                                            </td>
                                    })}
                                     <td>
                                        <span style={{ color: Number(payment?.amount) < 0 ? "red" : "green",fontWeight:"bold" }}>
                                            {money(payment?.amount)}
                                        </span>
                                     </td>

                                </tr>

                                </>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
            <table >
                <thead>
                    <th colSpan={5}>

                        <small style={{margin:"5px"}}>
                            تاريخ الطباعة
                        </small>
                        -
                        <small style={{margin:"5px"}} dir='rtl'>
                            {moment(new Date()).format("YYYY-MM-DD")}
                        </small>
                        -
                        <small style={{margin:"5px"}} dir='ltr'>
                            {moment(new Date()).format("LT")}
                        </small>
                    </th>
                </thead>
            </table>
            <FooterInvoice></FooterInvoice>
        </div>
    </div>
    );
}
export default InvoicePaymentsDay;